import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTeacherReviews,
  createTeacherReview,
  updateTeacherReview,
  deleteTeacherReview,
} from "./operations.js";

const initialState = {
  reviews: [],
  loading: false,
  error: null,
};

const teacherReviewsSlice = createSlice({
  name: "teacherReviews",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherReviews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherReviews.fulfilled, (state, action) => {
        state.loading = false;
        state.reviews = action.payload;
      })
      .addCase(fetchTeacherReviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // CREATE
      .addCase(createTeacherReview.fulfilled, (state, action) => {
        const newReview = action.payload;

        const index = state.reviews.findIndex(
          (r) => r.student_id === newReview.student_id
        );

        if (index !== -1) {
          state.reviews[index] = newReview;
        } else {
          state.reviews.unshift(newReview);
        }
      })
      .addCase(createTeacherReview.rejected, (state, action) => {
        state.error = action.payload;
      })
      // UPDATE
      .addCase(updateTeacherReview.fulfilled, (state, action) => {
        const index = state.reviews.findIndex(
          (r) => r.id === action.payload.id
        );
        if (index !== -1) {
          state.reviews[index] = action.payload;
        }
      })

      // DELETE
      .addCase(deleteTeacherReview.fulfilled, (state, action) => {
        state.reviews = state.reviews.filter(
          (r) => r.student_id !== action.payload.student_id
        );
      });
  },
});

export default teacherReviewsSlice.reducer;
